import React, { FC } from 'react'

import { Typography } from '@smarty-nx/ds'
import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'

import { content } from './chat-details.content'
import classes from './chat-details.module.scss'
import GenesysIcon from '../../static/images/icons/genesys-webchat.svg'
import { PromiseGenesys } from '../../utils/genesys'
import ColorButton from '../ColorButton'

const chatButtonProps = {
  'data-item-category': TRACKING_CATEGORIES.CONTACT,
  'data-item-name': content.dataItemName,
  'data-testid': 'email-button',
  onClick: () => PromiseGenesys('command', 'Messenger.open', {}),
  id: undefined,
}

export const ChatDetails: FC = () => (
  <div className={classes.intercomWrapper}>
    <div className={classes.wrapper}>
      <div className={classes.column}>
        <img
          {...chatButtonProps}
          className={classes.chatImage}
          src={GenesysIcon}
          alt="Intercom icon"
          data-testid="intercom-icon"
        />
      </div>
      <div className={classes.column}>
        <Typography
          variant="Kollektif/SmallEmphasis"
          component="h3"
          className={classes.title}
          data-testid="chat-title"
        >
          {content.chatTitle}
        </Typography>
        <Typography
          variant="Kollektif/Small"
          data-testid="email-text"
          className={classes.text}
        >
          {content.emailText}
        </Typography>
        <div className={classes.buttonWrapper}>
          <ColorButton level="tertiary" {...chatButtonProps}>
            {content.ctaText}
          </ColorButton>
        </div>
        <Typography variant="Kollektif/Tiny" data-testid="wait-times-text">
          {content.waitTimesAndOutsideOpeningTimes}
        </Typography>
      </div>
    </div>
  </div>
)
